/**
 * Responsibility: Shape admin role grants into field-assist form metadata and values.
 * Scope: Admin role form metadata/value normalization only; persistence stays elsewhere.
 */
import type { FormMetaData } from 'field-assist'
import type { AdminRoleGrant, AdminUserRole } from '../../admin/admin-contract'

const ROLE_OPTIONS: Array<{ text: string; value: Exclude<AdminUserRole, 'supreme'> }> = [
  { text: 'Normal', value: 'normal' },
  { text: 'Creator', value: 'creator' },
  { text: 'Moderator', value: 'moderator' },
  { text: 'Admin', value: 'admin' },
]

export function buildAdminRoleInitialValues(grant?: Partial<AdminRoleGrant>): Record<string, string> {
  return {
    email: String(grant?.email ?? ''),
    uid: String(grant?.uid ?? ''),
    displayName: String(grant?.displayName ?? ''),
    role: grant?.role && grant.role !== 'supreme' ? grant.role : 'normal',
  }
}

export function buildAdminRoleFormMeta(): FormMetaData {
  return {
    email: {
      label: 'User Email',
      componentType: 'input',
      attributes: {
        type: 'email',
        placeholder: 'name@example.com',
        class: 'admin-role-input',
      },
    },
      uid: {
        label: 'User UID',
        componentType: 'input',
        attributes: {
          type: 'text',
          placeholder: 'Supabase user id (optional)',
          class: 'admin-role-input',
        },
      },
    displayName: {
      label: 'Display Name',
      componentType: 'input',
      attributes: {
        type: 'text',
        placeholder: 'optional label',
        class: 'admin-role-input',
      },
    },
    role: {
      label: 'Assigned Role',
      componentType: 'select',
      options: ROLE_OPTIONS,
      attributes: {
        class: 'admin-role-select',
      },
    },
  }
}

export function buildAdminRoleSubmission(values: Record<string, unknown>): AdminRoleGrant {
  const rawRole = String(values.role ?? 'normal')
  const role: Exclude<AdminUserRole, 'supreme'> = ROLE_OPTIONS.some(option => option.value === rawRole as Exclude<AdminUserRole, 'supreme'>)
    ? rawRole as Exclude<AdminUserRole, 'supreme'>
    : 'normal'
  return {
    email: String(values.email ?? '').trim().toLowerCase(),
    uid: String(values.uid ?? '').trim(),
    displayName: String(values.displayName ?? '').trim(),
    role,
  }
}
